var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-select" },
    [
      _c("el-input", {
        staticStyle: { border: "none" },
        attrs: {
          disabled: _vm.disabled,
          placeholder: "请选择分公司",
          readOnly: "",
          value: _vm.value ? _vm.value.subCompanyName : "",
        },
        nativeOn: {
          click: function ($event) {
            return _vm.openModal.apply(null, arguments)
          },
        },
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }